import { render, staticRenderFns } from "./EmptySiteName.vue?vue&type=template&id=13e129f8"
import script from "./EmptySiteName.vue?vue&type=script&lang=js"
export * from "./EmptySiteName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports